import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./OperatorWidget.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";

const OperatorWidget = ({ operatorEmail, isOperatorMode, logout }) => {
	const handleLogout = useCallback(() => {
		if (typeof logout === "function") {
			logout();
		}
	}, []);

	if (!isOperatorMode) {
		return null;
	}

	return (
		<div className="operator-widget" data-testid="operator-widget">
			<div className="operator-widget__email">
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>
					<FormattedMessage
						id="general.operator.label"
						values={{
							operatorEmail: <strong>{operatorEmail}</strong>,
						}}
					/>
				</Typography>

				<Button variant="primary" onClick={handleLogout}>
					<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold>
						<FormattedMessage id="menu.item.logout" />
					</Typography>
				</Button>
			</div>
		</div>
	);
};

OperatorWidget.propTypes = {
	operatorEmail: PropTypes.string,
	isOperatorMode: PropTypes.string,
	logout: PropTypes.func,
};

export default memo(OperatorWidget);
